import React, { Component } from 'react';
import { Button, Alert, Row, Col } from 'reactstrap';

import ReactTooltip from 'react-tooltip';

import { WorkOrderIntForm } from './WorkOrderIntForm';
import { WorkOrderIntFormEndTime } from './WorkOrderIntFormEndTime';
import { WorkOrderIntFormEndTimeComment } from './WorkOrderIntFormEndTimeComment';
import { WorkOrderIntTableActive } from './WorkOrderIntTableActive';
import { WorkOrderIntTableHistory } from './WorkOrderIntTableHistory';
import { WorkOrderIntTableActiveSmall } from './WorkOrderIntTableActiveSmall';
import { WorkOrderIntTableHistorySmall } from './WorkOrderIntTableHistorySmall';
import { WorkOrderIntNoLongerAssigned } from './WorkOrderIntNoLongerAssigned';

import { LoadingModal } from './LoadingModal';

import { FetchData, FetchFile } from './utils/DataFetch';
import { saveAs } from 'file-saver';
import { GetParameterByName, GetCookie, Timeout } from './utils/Common';

import { WorkOrderIntConfNo } from './WorkOrderIntConfNo';
export class WorkOrderInt extends Component {
  static displayName = WorkOrderInt.name;

  constructor(props) {
    super(props);
    this.state = {
      workOrderList: [],
      jobHistoryList: [],
      jobInvLineList: [],

      executiveUsers: [],

      receivableList: [],
      receivableItemList: [],

      loading: true,
      modal: false,
      modalEndingTime: false,
      modalEndTimeComment: false,
      commentFinishTime: '',
      modalIntNoLongerAssigned: false,
      activeView: 'active',

      fetchingData: false,
      modalIntFormEmail: false,
      modalRepFormEmail: false,
      modalWOJobNotes: false,
      multiFilter: false,
      selectedIndex: -1,
      checkAll: false,
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
      model: {
        EventType: 'insert',
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: null,
        ProviderName: '',
        ConfCallNote: '',
        AptName: '',
        AptStreet: '',
        AptCity: '',
        AptState: '',
        AptZip: '',
        AptPhone: '',
        AptDirection: '',
        FailedFlg: false,
        CallerNote: '',
        InvoiceNote: '',
        IntCheckDate: null,
        IntCheckNum: null,
        InvoicedFlg: false,
        JobTotal: null,
        JobDiscount: null,
        IntFee: null,
        IntFeeOther: null,
        IntOTFee: null,
        IntFeeNote: '',
        TransportationFlg: false,
        TransConfFlg: false,
        IntConfFlg: false,
        AppointmentTypeId: '9e5e4810-c5a8-428b-8f7d-71422b6b77e3', // conf call
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: false,
        IsDeletedFlg: false,
        BillReviewedFlg: false,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: false,
        ClmId: '',
        ClmFirstName: '',
        ClmLastName: '',
        ClmClaimNumber: '',
        ClmClaimNumberNoDash: '',
        ClmPhone: '',
        ClmDateOfLoss: '',
        ClmDateOfInjury: '',
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmDateOfLossDate: null,
        ClmNote: '',
        ClmDOB: null,
        ClmInsuredParty: '',
        ClmEmployer: '',
        ClmInvoiceCaption: '',
        ClmLanguage: '',
        ClmWCABNumber: '',
        ClmInvoiceType: '',
        ClmStreet: '',
        ClmCity: '',
        ClmState: '',
        ClmZip: '',
        ClmSSN: '',
        ClmOrderedByName: '',
        ClmDiagnosis: '',
        ClmEmail: '',
        RepId: null,
        RepFirstName: '',
        RepLastName: '',
        RepPhone: '',
        RepEmail: '',
        ClientId: '',
        ClientAbbrv: '',
        ClientName: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientPhone: '',
        ClientPhoneFax: '',
        ClientPhone2: '',
        ClientEmail: '',
        ClientInactiveFlg: false,
        IntId: null,
        IntLastName: '',
        IntFirstName: '',
        IntCellTxt: '',
        IntPhoneOnly: '',
        IntEmail: '',
        IntNote: '',
        InHouseFlg: false,
        IntCity: '',
        IntStreet: '',
        IntState: '',
        IntZip: '',
        DBA: '',
        Rate: 0,
        HourMinimum: 0,
        Prorate: '',
        BankRoute: '',
        BankAccount: '',
        IntSSINumber: '',
        FirstName: '',
        LastName: '',
        UserType: '',
        UserIntId: null,
        CreateDateTime: null,
        CreateByUserId: null,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false,
        RemType: null,
        RemTypeDesc: '',
        RemHost: null,
        RemHostDesc: '',
        CreatedBy: '',
        UpdatedBy: '',
        MyJobTJobHistory: '',
        JobBalance: null,
      },
      client: {
        EventType: 'update',
        ClientId: null,
        ClientAbbrv: '',
        ClientPhone: '',
        ClientPhone2: '',
        ClientPhoneFax: '',
        ClientName: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientCountry: '',
        ClientDiscount: null,
        ClientNotes: '',
        ClientCreditCard: '',
        ClientEmailForInvoice: '',
        ClientEmail: '',
        ClientWebsite: '',
        ClientOrg: '',
        ClientBillRateType: '',
        ClientInactiveFlg: false,
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      searchModel: {
        IntId: '',
        ClmId: '',
        JobNum: null,
        StartDate: '',
        EndDate: '',
        Claimant: '',
        ClaimantNum: '',
        CLMPhone: '',
        Interpreter: '',
        Rep: '',
        ClientAbbrv: '',
        ProviderName: '',
        CreatedByUserId: null,
        MyJobs: false,
        MyJobsUser: '',
        SortBy: 'jobDateTime',
        SortDirection: 'desc',
      },
      email: {
        EmailFrom: '',
        EmailTo: '',
        EmailCC: '',
        Subject: '',
        Body: '',
        JobIds: '',
      },
      dayNames: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],

      tableView: 'default',

      modalEmailConfirm: false,
      emailConfirm: {
        notify_type: '',
        JobId: null,
        IntId: null,
      },
    };
    //
    this.user = JSON.parse(GetCookie('user'));

    // functions
    this.setModalEmailConfirm = this.setModalEmailConfirm.bind(this);
    this.setModalEndTimeComment = this.setModalEndTimeComment.bind(this);
    this.setModalIntNoLongerAssigned =
      this.setModalIntNoLongerAssigned.bind(this);

    //
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleSaveEventIntEndTimeSuccess =
      this.handleSaveEventIntEndTimeSuccess.bind(this);
    this.handleSaveEventSuccessComment =
      this.handleSaveEventSuccessComment.bind(this);

    // button clicks
    this.setData = this.setData.bind(this);
    this.setModal = this.setModal.bind(this);
    this.setModalEndingTime = this.setModalEndingTime.bind(this);
    //
    this.renderWorkOrderTableActive =
      this.renderWorkOrderTableActive.bind(this);
    this.renderWorkOrderTableHistory =
      this.renderWorkOrderTableHistory.bind(this);
    //
    this.requestSort = this.requestSort.bind(this);
    //
    this.handleEndintTimeClick = this.handleEndintTimeClick.bind(this);

    //
    this.handleActiveClick = this.handleActiveClick.bind(this);
    this.handleHistoryClick = this.handleHistoryClick.bind(this);
  }

  componentDidMount() {
    this.popluateWorkOrderIntData();
    if (this.props.isMyJob) this.populateExecutiveUsers();

    // Check for jobid parameter and what type of form to display
    if (GetParameterByName('jobid') !== null) {
      const jobId = GetParameterByName('jobid');
      const isFinalConf = GetParameterByName('IntFinalConf') === '1';
      const isEndTime = GetParameterByName('IntEndTime') === '1';

      FetchData(
        '/ValidateJobInterpreter/?jobId=' + jobId,
        'POST',
        this.user.token,
        {},
      ).then((data) => {
        if (data === 'Success') {
          // If successful validation, get the job data
          FetchData(
            '/getworkorder?jobId=' + jobId,
            'POST',
            this.user.token,
            null,
          ).then((woData) => {
            if (isEndTime) {
              // For End Time form
              this.handleEndintTimeClick(woData, -1, true);
            } else if (isFinalConf) {
              // For Final Confirmation form
              this.setData(woData, true);
            } else {
              // If no special parameter, just load the data without opening a modal
              this.setData(woData, false);
            }
          });
        } else {
          // If validation fails, show the modal for not assigned
          this.setModalIntNoLongerAssigned();
        }
      });
    }
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  setModal() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        if (!this.state.modal) {
          this.setState({
            selectedIndex: -1,
          });
        }
      },
    );
  }

  setModalEndingTime() {
    this.setState(
      {
        modalEndingTime: !this.state.modalEndingTime,
      },
      () => {},
    );
  }

  setModalEndTimeComment() {
    this.setState({ modalEndTimeComment: !this.state.modalEndTimeComment });
  }

  setModalEmailConfirm() {
    this.setState({ modalEmailConfirm: !this.state.modalEmailConfirm });
  }

  setModalIntNoLongerAssigned() {
    this.setState({
      modalIntNoLongerAssigned: !this.state.modalIntNoLongerAssigned,
    });
  }

  setData(woData, showModal) {
    this.setState((prevState) => ({
      model: {
        EventType: 'update',
        JobNum: woData.jobNum,
        JobId: woData.jobId,
        JobDateTime: woData.jobDateTime,
        JobTime: woData.jobTime,
        FinishTime: woData.finishTime,
        FinishTimeString:
          woData.finishTimeString === '00:00' ? null : woData.finishTimeString,
        FollowupDate: woData.followupDate,
        ProvId: woData.provId,
        ProviderName: woData.providerName,
        ConfCallNote: woData.confCallNote,
        AptName: woData.aptName,
        AptStreet: woData.aptStreet,
        AptCity: woData.aptCity,
        AptState: woData.aptState,
        AptZip: woData.aptZip,
        AptPhone: woData.aptPhone,
        AptDirection: woData.aptDirection,
        FailedFlg: woData.failedFlg,
        CallerNote: woData.callerNote,
        InvoiceNote: woData.invoiceNote,
        IntCheckDate: woData.intCheckDate,
        IntCheckNum: woData.intCheckNum,
        InvoicedFlg: woData.invoicedFlg,
        JobTotal: woData.jobTotal,
        JobDiscount: woData.jobDiscount,
        IntFee: woData.intFee === null ? null : woData.intFee, //parseFloat(woData.intFee).toFixed(2),
        IntFeeOther: woData.intFeeOther === null ? null : woData.intFeeOther, //parseFloat(woData.intFeeOther).toFixed(2),
        IntOTFee: woData.intOTFee === null ? null : woData.intOTFe, //parseFloat(woData.intOTFee).toFixed(2),
        IntFeeNote: woData.intFeeNote,
        TransportationFlg: woData.transportationFlg,
        TransConfFlg: woData.transConfFlg,
        IntConfFlg: woData.intConfFlg,
        AppointmentTypeId: woData.appointmentTypeId,
        CallerType: woData.callerType,
        ProvConfFlg: woData.provConfFlg,
        ClmConfFlg: woData.clmConfFlg,
        IsDeletedFlg: woData.isDeletedFlg,
        BillReviewedFlg: woData.billReviewedFlg,
        AuditFlg: woData.auditFlg,
        PurpleReportFlg: woData.purpleReportFlg,
        RepAuthorizedFlg: woData.repAuthorizedFlg,
        SelectedFlg: woData.selectedFlg,
        ClmId: woData.clmId,
        ClmFirstName: woData.clmFirstName,
        ClmLastName: woData.clmLastName,
        ClmClaimNumber: woData.clmClaimNumber,
        ClmClaimNumberNoDash: woData.clmClaimNumberNoDash,
        ClmPhone: woData.clmPhone,
        ClmDateOfLoss: woData.clmDateOfLoss,
        ClmDateOfInjury: woData.clmDateOfInjury,
        ClmDateOfInjuryStart: woData.clmDateOfInjuryStart,
        ClmDateOfInjuryEnd: woData.clmDateOfInjuryEnd,
        ClmDateOfLossDate: woData.clmDateOfLossDate,
        ClmNote: woData.clmNote,
        ClmDOB: woData.clmDOB,
        ClmInsuredParty: woData.clmInsuredParty,
        ClmEmployer: woData.clmEmployer,
        ClmInvoiceCaption: woData.clmInvoiceCaption,
        ClmLanguage: woData.clmLanguage,
        ClmWCABNumber: woData.clmWCABNumber,
        ClmInvoiceType: woData.clmInvoiceType,
        ClmStreet: woData.clmStreet,
        ClmCity: woData.clmCity,
        ClmState: woData.clmState,
        ClmZip: woData.clmZip,
        ClmSSN: woData.clmSSN,
        ClmOrderedByName: woData.clmOrderedByName,
        ClmDiagnosis: woData.clmDiagnosis,
        ClmEmail: woData.clmEmail,
        RepId: woData.repId,
        RepFirstName: woData.repFirstName,
        RepLastName: woData.repLastName,
        RepPhone: woData.repPhone,
        RepEmail: woData.repEmail,
        ClientId: woData.clientId,
        ClientAbbrv: woData.clientAbbrv,
        ClientName: woData.clientName,
        ClientStreet: woData.clientStreet,
        ClientStreet2: woData.clientStreet2,
        ClientCity: woData.clientCity,
        ClientState: woData.clientState,
        ClientZip: woData.clientZip,
        ClientMailStreet: woData.clientMailStreet,
        ClientMailStreet2: woData.clientMailStreet2,
        ClientMailCity: woData.clientMailCity,
        ClientMailState: woData.clientMailState,
        ClientMailZip: woData.clientMailZip,
        ClientPhone: woData.clientPhone,
        ClientPhoneFax: woData.clientPhoneFax,
        ClientPhone2: woData.clientPhone2,
        ClientEmail: woData.clientEmail,
        ClientInactiveFlg: woData.clientInactiveFlg,
        IntId: woData.intId,
        IntLastName: woData.intLastName,
        IntFirstName: woData.intFirstName,
        IntCellTxt: woData.intCellTxt,
        IntPhoneOnly: woData.intPhoneOnly,
        IntEmail: woData.intEmail,
        IntNote: woData.intNote,
        InHouseFlg: woData.inHouseFlg,
        IntCity: woData.intCity,
        IntStreet: woData.intStreet,
        IntState: woData.intState,
        IntZip: woData.intZip,
        DBA: woData.dDBA,
        Rate: woData.rate,
        HourMinimum: woData.hourMinimum,
        Prorate: woData.prorate,
        BankRoute: woData.bankRoute,
        BankAccount: woData.bankAccount,
        IntSSINumber: woData.intSSINumber,
        FirstName: woData.firstName,
        LastName: woData.lastName,
        UserType: woData.userType,
        UserIntId: woData.userIntId,
        CreateDateTime: woData.createDateTime,
        CreateByUserId: woData.createByUserId,
        UpdateDateTime: woData.updateDateTime,
        UpdateByUserId: woData.updateByUserId,
        RemIntFlg: woData.remIntFlg,
        RemClaimFlg: woData.remClaimFlg,
        RemProvFlg: woData.remProvFlg,
        RemFinalFlg: woData.remFinalFlg,
        RemType: woData.remType,
        RemTypeDesc: woData.remTypeDesc,
        RemHost: woData.remHost,
        RemHostDesc: woData.remHostDesc,
        CreatedBy: woData.createdBy,
        UpdatedBy: woData.updatedBy,
        MyJobTJobHistory: woData.myJobTJobHistory,
        JobBalance: woData.jobBalance,
      },
      modal: showModal,
    }));
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        if (alert.modal === false)
          if (this.state.tableView === 'default')
            this.popluateWorkOrderIntData();
          else this.populateWorkOrderPendingData();
      },
    );
  }

  handleSaveEventIntEndTimeSuccess(alert) {
    const modalEndingTime =
      typeof alert.modalEndingTime === 'boolean'
        ? alert.modalEndingTime
        : alert.modal;

    this.setState(
      {
        modalEndingTime: modalEndingTime,
        commentFinishTime: alert.finishTimeString || '',
        // skipParentAlert: the End Time modal already showed this message itself before
        // closing (e.g. the >24-hours-old follow-up warning) -- don't show it a second time
        // over the job list.
        alert: alert.skipParentAlert
          ? { color: alert.color, message: '', isOpen: false }
          : {
              color: alert.color,
              message: alert.message,
              isOpen: true,
            },
      },
      () => {
        if (alert.showTimeout != null) {
          this.setState({ alert: { isOpen: false } });
          this.setModalEndTimeComment();
        } else {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
            this.setModalEndTimeComment();
          }, Timeout(alert.message));
        }

        if (alert.modal === false) this.popluateWorkOrderIntData();
      },
    );
  }

  handleSaveEventSuccessComment(alert) {
    const modalEndTimeComment =
      typeof alert.modalEndTimeComment === 'boolean'
        ? alert.modalEndTimeComment
        : alert.modal;

    this.setState(
      {
        modalEndTimeComment: modalEndTimeComment,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      },
    );
  }

  sortData(sortBy, sortOrder, rows) {
    var itemsToSort = this.state.workOrderList;
    var sortedItems = [];
    var compareFn = null;

    compareFn = (i, j) => {
      if (i[sortBy] < j[sortBy]) {
        return sortOrder === 'asc' ? -1 : 1;
      } else {
        if (i[sortBy] > j[sortBy]) {
          return sortOrder === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
    };

    sortedItems = itemsToSort.sort(compareFn);
    return sortedItems;
  }

  handleActiveClick() {
    this.popluateWorkOrderIntData('active');
  }

  handleHistoryClick() {
    this.popluateWorkOrderIntData('history');
  }

  requestSort(pSortBy) {
    var sortBy = this.state.searchModel.SortBy;
    var sortOrder = this.state.searchModel.SortDirection;
    return (event) => {
      if (pSortBy === this.state.searchModel.SortBy) {
        sortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        sortBy = pSortBy;
        sortOrder = 'asc';
      }
      var sortedItems = this.sortData(sortBy, sortOrder);
      this.setState({
        searchModel: {
          SortBy: sortBy,
          SortDirection: sortOrder,
        },
        workOrderList: sortedItems,
      });
    };
  }

  handleEndintTimeClick(woData, rowIndex, showModal) {
    this.setState((prevState) => ({
      model: {
        EventType: 'update',
        JobNum: woData.jobNum,
        JobId: woData.jobId,
        JobDateTime: woData.jobDateTime,
        JobTime: woData.jobTime,
        FinishTime: woData.finishTime,
        FinishTimeString:
          woData.finishTimeString === '00:00' ? null : woData.finishTimeString,
        FollowupDate: woData.followupDate,
        ProvId: woData.provId,
        ProviderName: woData.providerName,
        ConfCallNote: woData.confCallNote,
        AptName: woData.aptName,
        AptStreet: woData.aptStreet,
        AptCity: woData.aptCity,
        AptState: woData.aptState,
        AptZip: woData.aptZip,
        AptPhone: woData.aptPhone,
        AptDirection: woData.aptDirection,
        FailedFlg: woData.failedFlg,
        CallerNote: woData.callerNote,
        InvoiceNote: woData.invoiceNote,
        IntCheckDate: woData.intCheckDate,
        IntCheckNum: woData.intCheckNum,
        InvoicedFlg: woData.invoicedFlg,
        JobTotal: woData.jobTotal,
        JobDiscount: woData.jobDiscount,
        IntFee: woData.intFee === null ? null : woData.intFee, //parseFloat(woData.intFee).toFixed(2),
        IntFeeOther: woData.intFeeOther === null ? null : woData.intFeeOther, //parseFloat(woData.intFeeOther).toFixed(2),
        IntOTFee: woData.intOTFee === null ? null : woData.intOTFe, //parseFloat(woData.intOTFee).toFixed(2),
        IntFeeNote: woData.intFeeNote,
        TransportationFlg: woData.transportationFlg,
        TransConfFlg: woData.transConfFlg,
        IntConfFlg: woData.intConfFlg,
        AppointmentTypeId: woData.appointmentTypeId,
        CallerType: woData.callerType,
        ProvConfFlg: woData.provConfFlg,
        ClmConfFlg: woData.clmConfFlg,
        IsDeletedFlg: woData.isDeletedFlg,
        BillReviewedFlg: woData.billReviewedFlg,
        AuditFlg: woData.auditFlg,
        PurpleReportFlg: woData.purpleReportFlg,
        RepAuthorizedFlg: woData.repAuthorizedFlg,
        SelectedFlg: woData.selectedFlg,
        ClmId: woData.clmId,
        ClmFirstName: woData.clmFirstName,
        ClmLastName: woData.clmLastName,
        ClmClaimNumber: woData.clmClaimNumber,
        ClmClaimNumberNoDash: woData.clmClaimNumberNoDash,
        ClmPhone: woData.clmPhone,
        ClmDateOfLoss: woData.clmDateOfLoss,
        ClmDateOfInjury: woData.clmDateOfInjury,
        ClmDateOfInjuryStart: woData.clmDateOfInjuryStart,
        ClmDateOfInjuryEnd: woData.clmDateOfInjuryEnd,
        ClmDateOfLossDate: woData.clmDateOfLossDate,
        ClmNote: woData.clmNote,
        ClmDOB: woData.clmDOB,
        ClmInsuredParty: woData.clmInsuredParty,
        ClmEmployer: woData.clmEmployer,
        ClmInvoiceCaption: woData.clmInvoiceCaption,
        ClmLanguage: woData.clmLanguage,
        ClmWCABNumber: woData.clmWCABNumber,
        ClmInvoiceType: woData.clmInvoiceType,
        ClmStreet: woData.clmStreet,
        ClmCity: woData.clmCity,
        ClmState: woData.clmState,
        ClmZip: woData.clmZip,
        ClmSSN: woData.clmSSN,
        ClmOrderedByName: woData.clmOrderedByName,
        ClmDiagnosis: woData.clmDiagnosis,
        ClmEmail: woData.clmEmail,
        RepId: woData.repId,
        RepFirstName: woData.repFirstName,
        RepLastName: woData.repLastName,
        RepPhone: woData.repPhone,
        RepEmail: woData.repEmail,
        ClientId: woData.clientId,
        ClientAbbrv: woData.clientAbbrv,
        ClientName: woData.clientName,
        ClientStreet: woData.clientStreet,
        ClientStreet2: woData.clientStreet2,
        ClientCity: woData.clientCity,
        ClientState: woData.clientState,
        ClientZip: woData.clientZip,
        ClientMailStreet: woData.clientMailStreet,
        ClientMailStreet2: woData.clientMailStreet2,
        ClientMailCity: woData.clientMailCity,
        ClientMailState: woData.clientMailState,
        ClientMailZip: woData.clientMailZip,
        ClientPhone: woData.clientPhone,
        ClientPhoneFax: woData.clientPhoneFax,
        ClientPhone2: woData.clientPhone2,
        ClientEmail: woData.clientEmail,
        ClientInactiveFlg: woData.clientInactiveFlg,
        IntId: woData.intId,
        IntLastName: woData.intLastName,
        IntFirstName: woData.intFirstName,
        IntCellTxt: woData.intCellTxt,
        IntPhoneOnly: woData.intPhoneOnly,
        IntEmail: woData.intEmail,
        IntNote: woData.intNote,
        InHouseFlg: woData.inHouseFlg,
        IntCity: woData.intCity,
        IntStreet: woData.intStreet,
        IntState: woData.intState,
        IntZip: woData.intZip,
        DBA: woData.dDBA,
        Rate: woData.rate,
        HourMinimum: woData.hourMinimum,
        Prorate: woData.prorate,
        BankRoute: woData.bankRoute,
        BankAccount: woData.bankAccount,
        IntSSINumber: woData.intSSINumber,
        FirstName: woData.firstName,
        LastName: woData.lastName,
        UserType: woData.userType,
        UserIntId: woData.userIntId,
        CreateDateTime: woData.createDateTime,
        CreateByUserId: woData.createByUserId,
        UpdateDateTime: woData.updateDateTime,
        UpdateByUserId: woData.updateByUserId,
        RemIntFlg: woData.remIntFlg,
        RemClaimFlg: woData.remClaimFlg,
        RemProvFlg: woData.remProvFlg,
        RemFinalFlg: woData.remFinalFlg,
        RemType: woData.remType,
        RemTypeDesc: woData.remTypeDesc,
        RemHost: woData.remHost,
        RemHostDesc: woData.remHostDesc,
        CreatedBy: woData.createdBy,
        UpdatedBy: woData.updatedBy,
        MyJobTJobHistory: woData.myJobTJobHistory,
        JobBalance: woData.jobBalance,
      },
      selectedIndex: rowIndex,
      modalEndingTime: showModal,
    }));
  }

  async popluateWorkOrderIntData(view = null) {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    model.IntId = this.user.intid;

    // Use the passed view parameter if provided, otherwise use state
    const activeView = view || this.state.activeView;

    // Choose the appropriate endpoint based on activeView
    const endpoint =
      activeView === 'active'
        ? '/getworkordersintactive'
        : '/getworkordersinthistory';

    this.setState({ searchModel: model }, () => {
      FetchData(endpoint, 'POST', this.user.token, model).then((data) => {
        this.setState({
          workOrderList: Array.isArray(data) ? data : [],
          loading: false,
          fetchingData: false,
          // Set activeView here if a view was passed
          ...(view && { activeView: view }),
        });
      });
    });
  }

  handleDownloadAttachment = async (jobHistoryId, fileName) => {
    const blob = await FetchFile('/getjobhistoryfile', 'POST', this.user.token, {
      JobHistoryId: jobHistoryId,
    });
    if (blob && blob.size > 0) {
      saveAs(blob, fileName);
    }
  };

  renderWorkOrderTableActive(workOrders) {
    return (
      <WorkOrderIntTableActive
        workOrders={this.state.workOrderList}
        handleEndIntTimeClick={this.handleEndintTimeClick}
        setData={this.setData}
        onDownloadAttachment={this.handleDownloadAttachment}
      ></WorkOrderIntTableActive>
    );
  }

  renderWorkOrderTableActiveSmall(workOrders) {
    return (
      <WorkOrderIntTableActiveSmall
        workOrders={this.state.workOrderList}
        handleEndIntTimeClick={this.handleEndintTimeClick}
        setData={this.setData}
        onDownloadAttachment={this.handleDownloadAttachment}
      ></WorkOrderIntTableActiveSmall>
    );
  }

  renderWorkOrderTableHistory(workOrders) {
    return (
      <WorkOrderIntTableHistory
        workOrders={this.state.workOrderList}
        handleEndIntTimeClick={this.handleEndintTimeClick}
        setData={this.setData}
        onDownloadAttachment={this.handleDownloadAttachment}
      ></WorkOrderIntTableHistory>
    );
  }

  renderWorkOrderTableHistorySmall(workOrders) {
    return (
      <WorkOrderIntTableHistorySmall
        workOrders={this.state.workOrderList}
        handleEndIntTimeClick={this.handleEndintTimeClick}
        setData={this.setData}
        onDownloadAttachment={this.handleDownloadAttachment}
      ></WorkOrderIntTableHistorySmall>
    );
  }

  render() {
    let activeView = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderWorkOrderTableActive(this.state.workOrderList)
    );
    let historyView = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderWorkOrderTableHistory(this.state.workOrderList)
    );

    let activeSmallView = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderWorkOrderTableActiveSmall(this.state.workOrderList)
    );

    let historySmallView = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderWorkOrderTableHistorySmall(this.state.workOrderList)
    );

    return (
      <div style={{ paddingTop: '12px' }}>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>

        <LoadingModal fetchingData={this.state.fetchingData} />

        <Row>
          <Col>
            <div style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
              <Button
                size="sm"
                className="btn-portal-action"
                style={{
                  backgroundColor:
                    this.state.activeView === 'active' ? '#ADD8E6' : 'white',
                  borderColor: 'black',
                  color: 'black',
                  padding: '10px 16px',
                  lineHeight: '1.2',
                  fontSize: '0.875rem',
                  minHeight: '44px',
                }}
                onClick={this.handleActiveClick}
              >
                Active Jobs
              </Button>
              <span style={{ paddingRight: '4px' }}></span>
              <Button
                size="sm"
                className="btn-portal-action"
                style={{
                  backgroundColor:
                    this.state.activeView === 'history' ? '#ADD8E6' : 'white',
                  borderColor: 'black',
                  color: 'black',
                  padding: '10px 16px',
                  lineHeight: '1.2',
                  fontSize: '0.875rem',
                  minHeight: '44px',
                }}
                onClick={this.handleHistoryClick}
              >
                History
              </Button>
            </div>
          </Col>
        </Row>

        <div className="d-none d-md-block">
          {' '}
          {this.state.activeView === 'active' ? activeView : historyView}
        </div>
        <div className="d-md-none">
          {' '}
          {this.state.activeView === 'active'
            ? activeSmallView
            : historySmallView}
        </div>

        {this.state.modal && (
          <WorkOrderIntForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            workOrderList={this.state.workOrderList}
            jobHistoryList={this.state.jobHistoryList}
            jobInvLineList={this.state.jobInvLineList}
            setNextPrevData={this.setNextPrevData}
            selectedIndex={this.state.selectedIndex}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
          />
        )}

        {this.state.modalEndingTime && (
          <WorkOrderIntFormEndTime
            model={this.state.model}
            modal={this.state.modalEndingTime}
            alert={this.state.alert}
            setModal={this.setModalEndingTime}
            handleSaveEventSuccess={this.handleSaveEventIntEndTimeSuccess}
            popluateWorkOrderIntData={this.popluateWorkOrderIntData}
          />
        )}

        {this.state.modalEndTimeComment && (
          <WorkOrderIntFormEndTimeComment
            jobmodel={this.state.model}
            finishTimeString={this.state.commentFinishTime}
            modal={this.state.modalEndTimeComment}
            alert={this.state.alert}
            setModal={this.setModalEndTimeComment}
            handleSaveEventSuccess={this.handleSaveEventSuccessComment}
          />
        )}

        {this.state.modalEmailConfirm && (
          <WorkOrderIntConfNo
            modal={this.state.modalEmailConfirm}
            alert={this.state.alert}
            setModal={this.setModalEmailConfirm}
            notify_type={this.state.emailConfirm.notify_type}
            JobId={this.state.emailConfirm.JobId}
            IntId={this.state.emailConfirm.IntId}
          />
        )}

        {this.state.modalIntNoLongerAssigned && (
          <WorkOrderIntNoLongerAssigned
            modal={this.state.modalIntNoLongerAssigned}
            setModal={this.setModalIntNoLongerAssigned}
          />
        )}
      </div>
    );
  }
}
